const TYPES = require('reducers/personalizedPromotions').ACTION_TYPES;
const ProfileApi = require('services/api/profile');
const UserUtils = require('utils/User');
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');
const CacheUtils = require('utils/Cache');
const DEFAULT_EXPIRY = Storage.MINUTES * 60;
const DELAY = Storage.MINUTES * 5;
const PST_OFFSET = 8;
const localeUtils = require('utils/LanguageLocale');

const updatePersonalizedPromotions = data => ({
    type: TYPES.UPDATE_PERSONALIZED_PROMOTIONS,
    data: data
});

const createEmptyPayload = profileId => ({
    profileId: profileId,
    items: [],
    loading: false
});

const { isBeautyOffersEnabled } = Sephora.configurationSettings;

const loadPersonalizedPromotions = () => (dispatch, getState) => {
    const {
        user,
        user: { profileId }
    } = getState();

    const payload = createEmptyPayload();
    payload.loading = true;
    dispatch(updatePersonalizedPromotions(payload));

    const cachedPromotions = Storage.local.getItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, false, true);
    const isUS = localeUtils.isUS();

    if (UserUtils.isAnonymous(user)) {
        dispatch(updatePersonalizedPromotions(createEmptyPayload()));
    } else if (cachedPromotions && cachedPromotions.profileId === profileId) {
        dispatch(updatePersonalizedPromotions(cachedPromotions));
    } else {
        ProfileApi.getPersonalizedPromotions(profileId, isUS)
            .then(data => {
                const showPromos = isBeautyOffersEnabled && isUS;
                const freshData = {
                    profileId,
                    items: showPromos ? data.allPromos.slice(0, 5) : data.personalizedPromotions || [],
                    loading: false,
                    hasNewPersonalizedPromotions: false
                };
                const userData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA, false, false, true);

                if (userData?.data?.personalizedPromotions?.hasNewPersonalizedPromotions) {
                    userData.data.personalizedPromotions.hasNewPersonalizedPromotions = false;
                    Storage.local.setItem(LOCAL_STORAGE.USER_DATA, userData.data, userData.expiry);
                }

                const expiry = CacheUtils.getLessOfTillMidnightOrDefault(DEFAULT_EXPIRY, DELAY, PST_OFFSET);
                Storage.local.setItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, freshData, expiry);
                dispatch(updatePersonalizedPromotions(freshData));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.error(error);
                dispatch(updatePersonalizedPromotions(createEmptyPayload(profileId)));
            });
    }
};

module.exports = {
    TYPES,
    loadPersonalizedPromotions,
    updatePersonalizedPromotions
};
